import { isEqual, isPlainObject } from 'lodash'
import { parseBooleanValue, logger } from '@/helpers'

function compare({ newVal, self }) {
    let changed

    // CUSTOM OBJECT
    if (self.field.type === 'custom-object') {
        const convertValue = val => {
            if (Array.isArray(val)) {
                if (val.length && val[0].key) {
                    return val.map(item => item.key)
                } else {
                    return val
                }
            } else {
                return []
            }
        }

        changed = !isEqual(convertValue(newVal), convertValue(self.lastSavedValue))

        // RELATION
    } else if (self.field.type === 'relation') {
        if (self.field.subForm.relateTo === 'variant') {
            const convertValue = val => {
                if (isPlainObject(val)) {
                    val = val.variants
                    if (val.length && val[0].id) {
                        return val.map(item => item.id)
                    } else {
                        return val
                    }
                } else {
                    return []
                }
            }

            changed = !isEqual(convertValue(newVal), convertValue(self.lastSavedValue))
        } else {
            const convertValue = val => {
                if (Array.isArray(val)) {
                    if (val.length && val[0].handle) {
                        return val.map(item => item.handle)
                    } else {
                        return val
                    }
                } else {
                    return []
                }
            }

            changed = !isEqual(convertValue(newVal), convertValue(self.lastSavedValue))
        }

        // BOOLEAN
    } else if (self.field.type === 'boolean') {
        const _prev = parseBooleanValue(self.lastSavedValue)
        const _new = parseBooleanValue(newVal)

        if (_prev === _new) {
            changed = false
        } else {
            changed = true
        }

        // OTHERS
    } else {
        changed = newVal != self.lastSavedValue // IMPORTRANT, I USE LOOSE INEQUALITY ( != ) ON PURPOSE!!
    }

    self.$emit('valueChanged', changed)
}

export function forSingleMetafield(watchDeep) {
    return {
        props: {
            field: Object
        },

        data() {
            return {
                lastSavedValue: null
            }
        },

        watch: {
            value: {
                handler(newVal) {
                    compare({ newVal, self: this })
                },
                deep: !!watchDeep
            }
        },

        methods: {
            setLastSavedValue(value) {
                this.lastSavedValue = value
            },
            afterSaveHandler() {
                this.setLastSavedValue(this.value)
                this.$store.commit('unsavedChanges/RESET_STATE')
            }
        },

        created() {
            this.setLastSavedValue(this.value)
            this.$eventBus.$on('AFTER_METAFIELDS_SUCCESS_SAVE', this.afterSaveHandler)
        },

        beforeDestroy() {
            this.$eventBus.$off('AFTER_METAFIELDS_SUCCESS_SAVE', this.afterSaveHandler)
        }
    }
}

export function forMetafieldsContainer() {
    return {
        props: {
            parentTheRepeater: Object,
            parentTheGroup: Object,
            groupTheRepeaterContainer: Object
        },

        methods: {
            findIfGroupChanged(group) {
                for (const key of Object.keys(group._childChanges)) {
                    const item = group._childChanges[key]
                    if (item) {
                        group.hasChanged = true
                        break
                    } else {
                        group.hasChanged = false
                    }
                }

                logger(`🔋 hasChanged - GROUP ${(group.key, group.hasChanged)}`, 'DEV')
            },
            setGroupChildChanged(bool, child) {
                const group = this.groupTheRepeaterContainer || this.parentTheGroup
                if (!group) return
                if (!group._childChanges) {
                    group._childChanges = {}
                }

                group._childChanges[child.key] = bool

                this.findIfGroupChanged(group)
            },
            setRepeaterChanged(repeater) {
                if (repeater.repeaterChildrenChanged || repeater.repeaterReorganized) {
                    repeater.hasChanged = true
                    this.setGroupChildChanged(true, repeater)
                } else {
                    repeater.hasChanged = false
                    this.setGroupChildChanged(false, repeater)
                }

                this.$store.commit('unsavedChanges/REGISTER_CHANGE', {
                    key: repeater.key,
                    bool: repeater.hasChanged
                })

                logger(`🔋 hasChanged - REPEATER ${(repeater.key, repeater.hasChanged)}`, 'DEV')
            },
            setRepeaterChildrenChanged(bool) {
                this.parentTheRepeater.repeaterChildrenChanged = bool
                this.setRepeaterChanged(this.parentTheRepeater)
            },
            setRepeaterReorganized(bool, repeater) {
                repeater.repeaterReorganized = bool
                this.setRepeaterChanged(repeater)
            },
            setFieldChanged(bool, field) {
                field.hasChanged = bool

                if (this.parentTheRepeater) {
                    if (!this.parentTheRepeater._childChanges) {
                        this.parentTheRepeater._childChanges = {}
                    }

                    this.parentTheRepeater._childChanges[field.key] = bool

                    for (const key of Object.keys(this.parentTheRepeater._childChanges)) {
                        if (this.parentTheRepeater._childChanges[key]) {
                            this.setRepeaterChildrenChanged(true)
                            break
                        } else {
                            this.setRepeaterChildrenChanged(false)
                        }
                    }
                } else {
                    this.setGroupChildChanged(bool, field)
                }

                this.$store.commit('unsavedChanges/REGISTER_CHANGE', {
                    key: field.key,
                    bool: field.hasChanged
                })

                logger(`🔋 hasChanged - FIELD ${(field.key, field.hasChanged)}`, 'DEV')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/metafields-changed-detection.mixin.js